var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoricon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 168,
    viewBox: "0 0 181 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4313 58.2197L19.5898 50.5708L26.5272 61.2437L14.4313 58.2197Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44592 96.998L4.46994 106.07L11.0515 98.7769L1.44592 96.998Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1669 140.046L24.2149 145.204L27.4167 135.243L18.1669 140.046Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8824 166.016L71.5313 165.66L67.2622 155.877L63.8824 166.016Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.242 166.372L118.314 163.348L110.488 155.165L109.242 166.372Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.444 142.358L155.67 135.776L144.819 130.618L149.444 142.358Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.65 92.1953L173.28 100.022L173.636 88.6377L160.65 92.1953Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.275 52.5278L177.905 49.5039L172.213 41.3213L165.275 52.5278Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.482 25.4897L142.15 13.2158L149.799 18.1965L139.482 25.4897Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.06 4.32129L103.016 15.172L109.954 6.27795L101.06 4.32129Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.676 15.7058L62.1037 25.6672L60.5028 12.5039L52.676 15.7058Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7192 73.873C50.7192 73.873 16.2101 34.9169 29.1954 24.5997C42.1808 14.2826 74.3774 56.4406 74.3774 56.4406C74.3774 56.4406 66.7285 1.83083 81.6706 0.0520157C96.6127 -1.90468 95.9011 51.9935 95.9011 51.9935C95.9011 51.9935 120.093 -2.08253 132.011 4.14333C143.929 10.5471 122.406 51.282 122.406 51.282C122.406 51.282 158.693 17.8402 166.342 27.4459C173.991 37.2294 135.569 71.2048 135.569 71.2048C135.569 71.2048 178.616 51.9936 180.395 66.5799C182.174 81.1662 136.636 88.6372 136.636 88.6372C136.636 88.6372 177.549 110.161 170.078 121.012C162.607 132.04 124.54 106.425 124.54 106.425C124.54 106.425 144.997 146.805 133.79 152.675C122.583 158.723 99.2809 117.632 99.2809 117.632C99.2809 117.632 102.483 164.415 89.4974 164.949C76.3341 165.482 73.8438 119.055 73.8438 119.055C73.8438 119.055 54.4547 165.838 42.3587 158.723C30.2627 151.429 54.4547 109.983 54.4547 109.983C54.4547 109.983 8.91688 139.867 3.04678 127.06C-2.64544 114.252 38.801 92.5506 38.801 92.5506C38.801 92.5506 0.912232 91.1275 1.80164 78.6758C3.04681 66.0462 50.7192 73.873 50.7192 73.873Z",
    fill: "#00587E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1849 62.1333C85.5839 60.8882 83.2715 61.2439 82.0263 62.667C80.7811 64.09 80.959 66.5804 82.382 68.0034C83.8051 69.2486 86.2954 69.2486 87.7185 67.8255C88.9637 66.4025 89.1416 63.7343 87.1849 62.1333Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9544 72.9834C71.3535 71.7382 69.041 72.094 67.7958 73.5171C66.5507 74.9401 66.7285 77.4305 68.1516 78.8535C69.5746 80.0987 72.065 80.0987 73.488 78.6757C74.7332 77.2526 75.089 74.5843 72.9544 72.9834Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9544 87.5703C71.3535 86.3252 69.041 86.6809 67.7958 88.104C66.5507 89.527 66.7285 92.0174 68.1516 93.4404C69.5746 94.6856 72.065 94.6856 73.488 93.2626C74.7332 91.8395 75.089 89.1713 72.9544 87.5703Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6898 103.224C75.0888 101.978 72.7763 102.334 71.5312 103.757C70.286 105.18 70.4639 107.671 71.8869 109.094C73.31 110.339 75.8004 110.339 77.2234 108.916C78.4686 107.493 78.8244 104.647 76.6898 103.224Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1656 103.224C90.5646 101.978 88.2522 102.334 87.007 103.757C85.7618 105.18 85.9397 107.671 87.3628 109.094C88.7858 110.339 91.2762 110.339 92.6992 108.916C93.9444 107.493 94.1223 104.647 92.1656 103.224Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.819 96.9976C106.218 95.7524 103.906 96.1082 102.661 97.5312C101.415 98.9543 101.593 101.445 103.016 102.868C104.439 104.113 106.93 104.113 108.353 102.69C109.42 101.267 109.776 98.5985 107.819 96.9976Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.156 81.3443C111.555 80.0991 109.242 80.4548 107.997 81.8779C106.752 83.301 106.93 85.7913 108.353 87.2144C109.776 88.4595 112.266 88.4596 113.689 87.0365C114.934 85.6135 115.112 82.9452 113.156 81.3443Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.108 67.8252C105.507 66.58 103.194 66.9358 101.949 68.3589C100.704 69.7819 100.882 72.2723 102.305 73.6953C103.728 74.9405 106.218 74.9405 107.641 73.5174C108.887 72.0944 109.064 69.4261 107.108 67.8252Z",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1995 89.349C77.4013 88.4596 80.6032 87.2145 83.6272 85.9693L101.415 72.9839",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1609 68.8926C84.3388 74.5848 84.1609 80.277 83.8052 85.9692V86.1471V86.325L88.4301 102.868",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1321 78.854C76.6897 81.1665 80.0695 83.4789 83.6271 85.9693L83.805 86.1472H83.9828L102.305 97.8873",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1561 102.868C79.0022 97.3538 81.4926 91.8394 83.8051 86.325C83.8051 86.325 83.8051 86.3251 83.8051 86.1472H83.9829L107.108 84.7241",
    stroke: "#F1ECE2",
    strokeWidth: 2.89182,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.887 49.6808C113.867 45.4117 119.026 40.4309 120.271 34.0272C120.449 33.1378 120.627 32.2484 120.271 31.359C120.093 30.4695 119.559 29.758 118.67 29.4022C117.425 29.0465 116.18 29.758 115.29 30.4695C112.8 32.6041 111.021 35.6281 109.954 38.83C108.887 42.3877 108.531 45.5895 108.887 49.6808Z",
    fill: "#149E99"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.517 48.9695C85.7622 42.3879 87.0073 35.4505 84.6949 29.0468C84.1612 27.4458 82.916 25.667 81.3151 25.8449C79.5363 25.8449 78.469 27.9795 78.2911 29.7583C77.046 36.162 79.8921 42.5657 84.517 48.9695Z",
    fill: "#149E99"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4356 57.8635C58.3683 54.4837 57.1232 50.9261 55.3444 47.7242C53.5655 44.5224 50.8973 41.6762 47.6954 40.2532C46.2723 39.7195 44.6714 39.3638 43.4262 40.2532C42.1811 41.3205 42.3589 43.4551 43.0705 45.056C44.3156 48.4358 46.9839 51.104 50.0079 53.0607C52.854 55.1953 56.0559 56.6183 59.4356 57.8635Z",
    fill: "#149E99"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2722 82.2332C41.2915 78.8534 35.4214 76.7188 29.3734 76.1852C28.1282 76.0073 26.883 76.0073 25.6379 76.3631C24.3927 76.7189 23.3254 77.6082 22.9696 78.6755C22.436 80.2765 23.3254 82.0553 24.7485 82.9447C26.1715 83.8341 27.9504 84.1899 29.5513 84.1899C34.8878 84.5456 39.8684 84.1899 46.2722 82.2332Z",
    fill: "#149E99"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6714 98.9542C38.2676 98.7764 31.8638 101.267 27.2389 105.714C26.3495 106.603 25.4601 107.493 25.1044 108.56C24.7486 109.627 24.7486 111.05 25.638 111.94C26.8831 113.185 29.0177 113.007 30.6186 112.473C36.133 110.517 40.2243 105.714 44.6714 98.9542Z",
    fill: "#149E99"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8153 117.276C60.325 119.411 57.8346 121.546 55.8779 124.214C53.9212 126.882 52.4982 130.084 52.3203 133.286C52.3203 134.175 52.3203 135.242 53.0318 135.598C53.9212 136.132 54.9885 135.598 55.7001 135.065C58.3683 133.286 60.1471 130.44 61.3923 127.416C62.6375 124.569 63.1711 121.368 62.8153 117.276Z",
    fill: "#149E99"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0073 122.613C85.5843 127.593 84.6949 132.752 85.0506 137.911C85.2285 139.156 85.4064 140.401 85.94 141.29C86.4737 142.358 87.7189 143.069 88.7861 143.069C89.8534 142.891 90.7428 142.18 91.2765 141.29C91.8101 140.401 91.8102 139.334 91.8102 138.266C91.988 133.108 89.8534 128.127 87.0073 122.613Z",
    fill: "#149E99"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M113.334 111.762C114.401 117.988 115.468 124.391 119.737 129.016C120.449 129.728 121.16 130.439 122.05 130.617C122.939 130.973 124.007 130.795 124.718 130.084C125.608 129.194 125.43 127.593 124.896 126.348C122.939 120.122 118.314 114.608 113.334 111.762Z",
    fill: "#149E99"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M135.035 100.555C138.059 104.824 142.151 108.382 146.775 110.694C148.021 111.406 149.622 111.939 151.045 111.406C152.29 110.872 152.823 109.271 152.646 107.848C152.468 106.425 151.578 105.358 150.511 104.468C148.554 102.689 146.064 101.622 143.574 101.089C141.083 100.377 138.415 100.199 135.035 100.555Z",
    fill: "#149E99"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.506 77.9643C146.242 74.4067 150.867 71.9163 155.847 70.3154C157.093 69.9596 158.516 69.6039 159.405 70.4933C160.472 71.3827 160.472 73.1615 159.761 74.2288C159.049 75.2961 157.626 76.0076 156.381 76.5412C152.646 77.9643 148.376 78.8537 142.506 77.9643Z",
    fill: "#149E99"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.3 57.6856C135.925 55.7289 140.727 53.7721 144.107 50.0366C144.819 49.1472 145.53 48.2578 145.708 47.1905C145.886 46.1232 145.708 44.8781 144.997 44.1665C143.929 43.2771 142.328 43.455 141.083 43.9886C138.593 45.0559 136.28 46.8347 134.502 48.9693C132.901 51.1039 131.478 53.5943 131.3 57.6856Z",
    fill: "#149E99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoricon01);
export default __webpack_public_path__ + "static/media/decoricon01.363c426f8f63dc45e2ae64968ef06c52.svg";
export { ForwardRef as ReactComponent };